"use client"

import { Info, Settings2, UserRound } from "lucide-react"

import { AgentToolCard } from "@/components/agents/shared/agent-tool-presentation"
import { Alert, AlertDescription } from "@/components/ui/alert"
import { Button } from "@/components/ui/button"

type CaptureCustomerInfoToolProps = {
  title: string
  description: string
  instructionsHint: string
  checked: boolean
  expanded: boolean
  disabled?: boolean
  isPending?: boolean
  onCheckedChange: (checked: boolean) => void
  onExpandedChange: (expanded: boolean) => void
  onOpenInstructions: () => void
}

export function CaptureCustomerInfoTool({
  title,
  description,
  instructionsHint,
  checked,
  expanded,
  disabled = false,
  isPending = false,
  onCheckedChange,
  onExpandedChange,
  onOpenInstructions,
}: CaptureCustomerInfoToolProps) {
  return (
    <AgentToolCard
      title={title}
      description={description}
      categoryLabel="General"
      tone="general"
      icon={UserRound}
      checked={checked}
      onCheckedChange={onCheckedChange}
      expanded={expanded}
      onExpandedChange={onExpandedChange}
      disabled={disabled}
      isPending={isPending}
    >
      <Button
        type="button"
        variant="outline"
        className="w-full"
        onClick={onOpenInstructions}
        disabled={disabled || isPending}
      >
        <Settings2 aria-hidden="true" className="mr-2 h-4 w-4" />
        <span>Customize Instructions</span>
      </Button>
      <Alert>
        <Info aria-hidden="true" className="h-4 w-4" />
        <AlertDescription>{instructionsHint}</AlertDescription>
      </Alert>
    </AgentToolCard>
  )
}
